"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReceiptLoyaltySection = exports.formatTenderedPoints = exports.formatRedeemedPointsForPaymentLine = exports.getRedeemedPointsForPaymentLine = exports.isRefundReceipt = exports.hasReceiptLoyalty = exports.formatPoints = exports.PENDING_NOTE = exports.RECEIPT_LOYALTY_LABELS = void 0;
const POINTS_LOCALE = 'en-CA';
const PLACEHOLDER_VALUE = '-';
exports.RECEIPT_LOYALTY_LABELS = {
    earned: 'Loyalty Earned',
    returned: 'Loyalty Returned',
    balance: 'Loyalty Balance',
    pendingEarned: 'Points earned',
    pendingBalance: 'Points balance',
};
/** Deliberately non-promissory: a pre-growth reprint sits in `pending` forever. */
exports.PENDING_NOTE = '- not shown on this receipt';
const formatPoints = (points) => `${points.toLocaleString(POINTS_LOCALE)} Points`;
exports.formatPoints = formatPoints;
/**
 * `{ status: 'none' }` is the server saying this merchant has loyalty off, and it is a truthy
 * object — a bare `receiptLoyalty &&` guard passes it and prints loyalty rows anyway. Nothing
 * else, here or in a renderer, tests the contract directly, so `none` and `undefined` mean the
 * same thing everywhere downstream.
 */
const hasReceiptLoyalty = (receiptLoyalty) => receiptLoyalty !== undefined && receiptLoyalty.status !== 'none';
exports.hasReceiptLoyalty = hasReceiptLoyalty;
/** Once `receiptLoyalty` is in play the refund flag comes off the payment itself. */
const isRefundReceipt = (payment, loyaltyData, receiptLoyalty) => (0, exports.hasReceiptLoyalty)(receiptLoyalty)
    ? !!payment.refundPaymentId
    : !!loyaltyData && (loyaltyData.loyaltyReversed || 0) < 0;
exports.isRefundReceipt = isRefundReceipt;
const getRedeemedPointsForPaymentLine = (receiptLoyalty, paymentLineId) => {
    if (!(0, exports.hasReceiptLoyalty)(receiptLoyalty)) {
        return null;
    }
    const matchingRedemptions = receiptLoyalty.redemptions.filter((redemption) => redemption.paymentLineId === paymentLineId);
    if (matchingRedemptions.length === 0) {
        return null;
    }
    return matchingRedemptions.reduce((total, redemption) => total + redemption.points, 0);
};
exports.getRedeemedPointsForPaymentLine = getRedeemedPointsForPaymentLine;
/**
 * The single home of the minus-sign rule. Retained deliberately: a bare `1,000 Points` under a
 * discount line reads as points *earned* on that item. Every renderer — HTML and non-HTML alike —
 * takes the formatted string from here rather than re-applying the sign itself.
 *
 * The magnitude is taken absolute before the sign goes on. The contract documents redemptions as
 * positive and homi-api normalizes legacy negatives, but sign is presentation's job, so exactly one
 * minus sign is guaranteed here rather than assumed of the caller — a negative slipping through
 * would otherwise print `--1,000 Points`.
 */
const formatRedeemedPointsForPaymentLine = (receiptLoyalty, paymentLineId) => {
    const redeemedPoints = (0, exports.getRedeemedPointsForPaymentLine)(receiptLoyalty, paymentLineId);
    return redeemedPoints === null ? null : `-${(0, exports.formatPoints)(Math.abs(redeemedPoints))}`;
};
exports.formatRedeemedPointsForPaymentLine = formatRedeemedPointsForPaymentLine;
/**
 * Sibling of `formatRedeemedPointsForPaymentLine` for the loyalty **tender** row — the
 * `-750 Points` under "Paid with Loyalty". Same minus-sign rule, a different row, and the
 * reason that rule is not re-applied by hand in every renderer that prints the row.
 *
 * Null means print nothing: nothing tendered, or a contract that says loyalty is off here.
 * The legacy `loyaltyData` path keeps its own say, so pre-contract receipts still print.
 */
const formatTenderedPoints = (receiptLoyalty, loyaltyData, points, isRefund) => {
    if (!loyaltyData && !(0, exports.hasReceiptLoyalty)(receiptLoyalty)) {
        return null;
    }
    if (points === null || points === undefined || points === 0) {
        return null;
    }
    const formatted = (0, exports.formatPoints)(Math.abs(points));
    return isRefund ? formatted : `-${formatted}`;
};
exports.formatTenderedPoints = formatTenderedPoints;
/** Null means print nothing — not the rows, and not the rule above them. */
const getReceiptLoyaltySection = (receiptLoyalty, isRefund) => {
    if (!(0, exports.hasReceiptLoyalty)(receiptLoyalty)) {
        return null;
    }
    if (receiptLoyalty.status === 'pending') {
        return {
            rows: [
                { label: exports.RECEIPT_LOYALTY_LABELS.pendingEarned, value: PLACEHOLDER_VALUE },
                { label: exports.RECEIPT_LOYALTY_LABELS.pendingBalance, value: PLACEHOLDER_VALUE },
            ],
            note: exports.PENDING_NOTE,
        };
    }
    const { pointsEarned, pointsBalanceAfterSale } = receiptLoyalty;
    const rows = [
        ...(pointsEarned === 0
            ? []
            : [
                {
                    label: isRefund ? exports.RECEIPT_LOYALTY_LABELS.returned : exports.RECEIPT_LOYALTY_LABELS.earned,
                    value: (0, exports.formatPoints)(pointsEarned),
                },
            ]),
        ...(pointsBalanceAfterSale === null
            ? []
            : [
                {
                    label: exports.RECEIPT_LOYALTY_LABELS.balance,
                    value: (0, exports.formatPoints)(pointsBalanceAfterSale),
                },
            ]),
    ];
    return rows.length === 0 ? null : { rows, note: null };
};
exports.getReceiptLoyaltySection = getReceiptLoyaltySection;
//# sourceMappingURL=receiptLoyalty.js.map